<template>
  <div class="w-100">
    <div class="row">
      <div class="col-12">
        <i-select v-model="type">
          <i-option
            v-for="(label, key) in $t('pbx.contact-method.type')"
            :key="key"
            :value="key"
            :label="label"
          />
        </i-select>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <component :is="`type-${type}`" :exist="exist" class="mt-3" @on-add="add_item" />
      </div>
    </div>
  </div>
</template>

<script>
  import TypeInternal from './internal';
  import TypeExternal from './external';
  import TypeSip from './sip';

  export default {
    components: {
      TypeInternal,
      TypeExternal,
      TypeSip
    },
    props: {
      exist: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        type: 'external'
      };
    },

    methods: {
      add_item: function(item) {
        this.$emit('on-add', { ...item, format_type: this.type });
      }
    }
  };
</script>
